import { isDesktopWindowSize, isMobileOrTabletWindowSize } from '../app-core/responsive';
import { useState, useEffect } from 'react';
import { debounce } from 'lodash';

export const RESIZE_THROTTLE  = 20;

/**
 * On Window resize event determines if the screen is a Desktop or Touch size.
 */
export const useMobileOrTableWindowResize = (): boolean => {
  const [isMobileOrTableWS, setIsMobileOrTableWS] = useState<boolean>(isMobileOrTabletWindowSize());

  useEffect(() => {
    const handleResize = () => {      
      if (isMobileOrTableWS && isDesktopWindowSize()) {
        setIsMobileOrTableWS(false);
      } 
  
      if (!isMobileOrTableWS && isMobileOrTabletWindowSize()) {
        setIsMobileOrTableWS(true);
      }
    };

    window.addEventListener('resize', debounce(handleResize, RESIZE_THROTTLE));

    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileOrTableWS]);

  return isMobileOrTableWS;
};
